interface FireResultCardProps {
  type: "Lean FIRE" | "Fat FIRE" | "Coast FIRE";
  amount: string;
  description: string;
  className?: string;
}

export function FireResultCard({
  type,
  amount,
  description,
  className = "",
}: FireResultCardProps) {
  return (
    <div
      className={`bg-[#2C2C2C] border border-[#808080] rounded-lg py-6 px-6 relative ${className}`}
    >
      <div className="flex flex-col h-full">
        <span className="inline-block px-3 py-1 rounded-full bg-[#F5EAC1]  text-[#000000] text-[11px] mb-4 w-fit">
          {type}
        </span>
        <div className="text-[#E6D5B8] text-[20px] font-semibold mb-2 bg-gradient-text text-transparent bg-clip-text">
          Rs {amount}
        </div>
        <p className="text-white text-[12px] pr-4 mr-4">{description}</p>
        <div className="absolute bottom-0 right-0">
          <img
            src={
              type === "Lean FIRE"
                ? "/assets/fire-calculator/lean-fire.png"
                : type === "Fat FIRE"
                  ? "/assets/fire-calculator/fat-fire.png"
                  : "/assets/fire-calculator/coast-fire.png"
            }
            alt=""
            className={`w-14 h-14 opacity-80 ${type === "Coast FIRE" ? "w-20 h-20" : "w-14 h-14"}`}
          />
        </div>
      </div>
    </div>
  );
}
